export default function useLogin() {
  /**
   * 检测手机号是否正确
   */
  function checkPhone(phone: string) {
    let res = ''
    // 先验证手机号的格式
    const phoneReg = /^1[1-9]\d{9}$/
    if (!phone) {
      res = '请先输入手机号'
    } else if (!phoneReg.test(phone)) {
      res = '请输入正确的手机号'
    } else {
      res = ''
    }
    return res
  }

  return {
    checkPhone
  }
}
